module.exports = __webpack_public_path__ + "img/Finland.0d5ddb6b.png";